import { render } from "./StepBarWithDescription.vue?vue&type=template&id=3918ff8c"
import script from "./StepBarWithDescription.vue?vue&type=script&lang=ts"
export * from "./StepBarWithDescription.vue?vue&type=script&lang=ts"
script.render = render

export default script